import apiClient from "./api-client.service";
import axios from "axios";
import AgentService from "./agent/agent.service";
import messages from "./agent/messages";
import { MatchResult } from "../Interface/Index";

class ProfileMatcherService {
  public static Events = {
    MATCH_RESULT_AVAILABLE: "match_result_available",
  };
  private APIBaseUrl: string = "";
  public result: any;

  private static instance: ProfileMatcherService;

  constructor() {
    if (ProfileMatcherService.instance) {
      return ProfileMatcherService.instance;
    }
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
    ProfileMatcherService.instance = this;
  }

  async uploadResumeToS3AndMatchProfile(file: File,applicationId: string) {
    try {
      const uploadData = await this.getResumeUploadUrl(file.name, file.type);

      if (!uploadData)
        throw new Error("Error while getting presigned upload url");

      const uploadFileResponse = await this.uploadResume(uploadData.url, file);

      if(!uploadFileResponse){
        throw new Error("Error while uploading resume to s3");
      }

      return await this.matchResumeWithJD(uploadData.fileName, applicationId);
    } catch (error: any) {
      throw new Error("Error while uploading resume to s3");
    }
  }

  async uploadResumeAndMatchJD(
    file: File,
    applicationId: string
  ): Promise<MatchResult | undefined> {
    try {
      const uploadData = await this.getResumeUploadUrl(file.name, file.type);

      const uploadFileResponse = await this.uploadResume(uploadData.url, file);

      if (uploadFileResponse) {
        const agentService = AgentService.getInstance();
        agentService.setCurrentMessage(
          messages.WAITING_FOR_MATCH_RESULTS,
          "",
          ""
        );
        const matchResult = await this.matchResumeWithJD(
          uploadData.fileName,
          applicationId
        );
        if (matchResult) {
          if (matchResult.status === "unqualified") {
            agentService.setCurrentMessage(
              messages.MATCH_RESULT_UNQUALIFIED,
              "",
              ""
            );

            return matchResult;
          }
        }
      }
    } catch (error) {
      throw new Error("Error while uploading resume and matching with JD");
    }
  }

  async getResumeUploadUrl(fileName: string, fileType: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/profile-matcher/upload?filename=${fileName}&fileType=${fileType}`
      );
      const data = response.data;
      return data;
    } catch (error) {
      console.log("Error while creating url", error);
    }
  }

  async uploadResume(url: string, file: File) {
    try {
      const response = await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });

      if (response.status === 200) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log("Error while uploading resume", error);
    }
  }

  async matchResumeWithJD(fileName: string, applicationId: string) {
    try {
      const formData = new FormData();
      formData.append("filename", fileName);
      formData.append("job_application_id", applicationId);
      const response = await apiClient.post(
        `${this.APIBaseUrl}/profile-matcher`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      this.result = data;
      return data;
    } catch (error) {
      console.log("Error while matching the resume", error);
    }
  }

  async getMatchResultByJobApplicationId(applicationId: string) {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/profile-matcher/match/${applicationId}`
      );
      const data = response.data;
      this.result = data[0];
      return data;
    } catch (error) {
      console.log("Error while fetching match result", error);
    }
  }

  async getAllUploadedProfiles() {
    try {
      const response = await apiClient.get(`${this.APIBaseUrl}/users/profile`);
      const data = response.data;
      console.log(
        "🚀 ~ ProfileMatcherService ~ getAllUploadedProfiles ~ data:",
        data
      );
      return data;
    } catch (error) {
      console.log(
        "🚀 ~ ProfileMatcherService ~ getAllUploadedProfiles ~ error:",
        error
      );
    }
  }

  async matchResumeWithJDWithoutUploadingFile(
    applicationId: string,
    profileId: string
  ) {
    try {
      AgentService.getInstance().setCurrentMessage(
        messages.WAITING_FOR_MATCH_RESULTS,
        "",
        ""
      );
      const formData = new FormData();
      formData.append("job_application_id", applicationId);
      formData.append("profile_id", profileId);
      const response = await apiClient.post(
        `${this.APIBaseUrl}/profile-matcher/match`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = response.data;
      if (data) {
        if (data.status === "unqualified") {
          AgentService.getInstance().setCurrentMessage(
            messages.MATCH_RESULT_UNQUALIFIED,
            "",
            ""
          );
        }
        return data;
      }
    } catch (error) {
      console.log(
        "🚀 ~ ProfileMatcherService ~ matchResumeWithJDWithoutUploadingFile ~ error:",
        error
      );
    }
  }
}

export default ProfileMatcherService;
